

import React, { createContext, useContext, Component } from "react";
import { GlobalContext } from "../utils/globalprovider.js"
import { getCurrentUserDatas, GetCurrentUserOptions } from "../utils/software.js";
import Button from "../components/bases/button/button";
import imgClose from "../upload/assets/close.png"
import { ApiWorkerTasksList, ApiWorkerTaskDelete, apiSaveUserOptions } from "../utils/apis.js";

import { SearchVideoProgress } from "../utils/videoutils.js";
import { SetCurrentUserDisplayTasks, GetCurrentUserDisplayTasks } from "../utils/software.js";

import TaskStatus from "./taskstatus.js";

import "./workertasks.css"

const MyComponentWorkerTasks = createContext();



class WorkerTasks extends Component {

  static contextType = GlobalContext; 

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false, // Indique si on est en train de drag
      offsetX: 0, // Décalage horizontal entre la souris et la div
      offsetY: 0, // Décalage vertical entre la souris et la div
      x: 100, // Position initiale horizontale
      y: 100, // Position initiale verticale
      visible: GetCurrentUserDisplayTasks(),
      videos: [],


    };
    // Liaison des méthodes
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    

    this.onClickOnDelete = this.onClickOnDelete.bind(this);
    this.onClickOnDeleteCallBack = this.onClickOnDeleteCallBack.bind(this);

    this.onQuit = this.onQuit.bind(this);

    this.workerListDivRef = React.createRef();

    this.readWorkerTasks = this.readWorkerTasks.bind(this);
    this.readWorkerTasksDone = this.readWorkerTasksDone.bind(this);
  }




  readWorkerTasks()
  {
    
    if (getCurrentUserDatas().id <=0 )
        this.setState({videos: [], visible: false})
    else
    {
        if (GetCurrentUserDisplayTasks())
            ApiWorkerTasksList(this.readWorkerTasksDone);
    }
  }

  readWorkerTasksDone(datas)
  {
    
    if (datas.length == 0)
        this.setState({visible:false})
    else
        this.setState({visible:GetCurrentUserDisplayTasks(), videos: datas});
  }
  handleMouseDown(event) {
    // Enregistre l'état de dragging et l'offset
    this.setState({
      isDragging: true,
      offsetX: event.clientX - this.state.x,
      offsetY: event.clientY - this.state.y,
    });
  }

  handleMouseMove(event) {
    // Si on est en train de drag, mettre à jour la position
    if (this.state.isDragging) {

      var innerdiv = document.getElementById("workertasksdiv");
      const rect = innerdiv.getBoundingClientRect();
      const maxx = window.innerWidth - rect.width- 60;
      const maxy = window.innerHeight - rect.height - 40;


      var x = event.clientX - this.state.offsetX;
      var y = event.clientY - this.state.offsetY;

      if ( x > maxx) x = maxx;
      if ( y > maxy) y = maxy;

      if ( x <20) x=20;
      if ( y < 2) y=2;

      
      this.setState({
        x: x,
        y: y,
      });


    }
  }

  handleMouseUp() {
    // Arrêter le dragging
    this.setState({ isDragging: false });
  }


  updatePosition ()
  {
    const { width, height } = this.parent.getBoundingClientRect();
    this.setState ({
        x: width - this.workerListDivRef.current.getBoundingClientRect().width - 30
        

    })
    
  }
  componentDidMount() {
    // Ajout des écouteurs globaux pour le déplacement et le relâchement
    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("mouseup", this.handleMouseUp);

    this.parent = this.workerListDivRef.current.parentElement;
    this.updatePosition();
    this.readWorkerTasks();

    this.interval = setInterval(() => {
        this.readWorkerTasks();
        }, 4000);    
    


  }

onClickOnDelete(videoid)
{
    ApiWorkerTaskDelete(videoid, this.onClickOnDeleteCallBack);
   
}

onClickOnDeleteCallBack(datas)
{
    this.readWorkerTasks();
}

  componentDidUpdate()
  {
    const { width, height } = this.parent.getBoundingClientRect();
    if (this.state.x > width - this.workerListDivRef.current.getBoundingClientRect().width - 30)
        this.updatePosition();
  }

  
  componentWillUnmount() {
    // Nettoyage des écouteurs pour éviter les fuites de mémoire
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("mouseup", this.handleMouseUp);
    clearInterval(this.interval);
  }


  onQuit()
  {
    // on ecrit ça
      this.setState({visible: false})
      SetCurrentUserDisplayTasks(false) ; // on ecrit dans 

      const datas = GetCurrentUserOptions();
      
      apiSaveUserOptions(datas, null);

      
  }

  
  render() {

    var display="flex";
    if (!this.state.visible) display="none";


    const { x, y } = this.state;
    
    return (
      <div className="WorkerTasksDiv" ref={this.workerListDivRef}
        id = "workertasksdiv"
        onMouseDown={this.handleMouseDown}
        style={{top: y, left: x,display:display}}
      >

        <div className="WorkerTasksTitle"
        onMouseDown={this.handleMouseDown}>
          <div className="WorkerTasksTitleText">
          {this.context.language=="fr"?"Traitements en cours":"Current Tasks"}
          </div>


          <div className="WorkerTasksCloseButton">
            <Button image={imgClose} width={16} height={16} onClick={this.onQuit}/>
          </div>

        </div>

        <div className = "WorkerTasksList">
            {
            
              
              
              this.state.videos.map((video) => {
            
                SearchVideoProgress(video);

                var text= this.context.language=="fr"?"Terminé.":"Finish.";
                var status = 0;
                var cupc = (video.pc / video.totalpc) * 100;
                cupc = Math.round(cupc)
                const wpc = Math.round((cupc * 95) / 100);

                if (video.errorlib !=="")
                {
                    status = -1;
                    text = video.errorlib;
                }
                else
                    if (video.finish)
                        status = 0;
                    else
                        status=1;

                return (
                        <div>
                            <TaskStatus 
                                id = {video.viid}
                                title = {video.vititle}
                                text = {text}
                                status = {status}
                                pourcent = {wpc}
                                date = '19650131'
                                onClick = {this.onClickOnDelete}
                                />
                        </div>
                )
                }
            )}
        </div>

        
      </div>
    );
  }
}

export default WorkerTasks;
